@if ((user$ | async) && (tokenService.isLoggedIn$ | async)) {
  <div class="user-menu-container">
    <div class="header">
      @if (emulationService.isEmulating) {
        <coin-v2-button
          class="stop-emulation-icon"
          icon="person"
          type="red"
          [text]="'header.user-menu.menu-item-stop-emulate' | translate"
          (click)="emulationService.removeEmulation()"></coin-v2-button>
      }

      <button
        class="no-style menu-toggle"
        [attr.aria-label]="((isMenuVisible$ | async) ? 'header.user-menu.close' : 'header.user-menu.open') | translate"
        (click)="toggleMenu()">
        @if (userImageSrc$ | async) {
          <div
            class="image"
            preventRightClick
            [ngStyle]="{ 'background-image': 'url(' + (userImageSrc$ | async) + ')' }"></div>
        } @else {
          <mat-icon class="image fallback-image">person</mat-icon>
        }

        <div class="user-info">
          <p
            showTooltipIfTruncated
            class="bold">
            {{ userDetails$ | async | name }}
          </p>
          @if (userDetails$ | async; as userDetails) {
            <p
              showTooltipIfTruncated
              class="org-code">
              {{ userDetails?.paOrgCode }}{{ userDetails?.paOrgCode && userDetails?.placeOfAction ? ', ' : ''
              }}{{ userDetails?.placeOfAction }}
            </p>
          }
        </div>
        <mat-icon
          class="toggle-icon"
          [class.open]="isMenuVisible$ | async">
          keyboard_arrow_down
        </mat-icon>
      </button>

      @if (remainingTokenTimeText$ | async; as remainingTime) {
        <button
          class="no-style token-time"
          [attr.aria-label]="'header.user-menu.refresh-token' | translate"
          (click)="renewToken()">
          <mat-icon class="clock">access_time</mat-icon>
          <mat-icon class="renew">autorenew</mat-icon>
          <p
            class="bold"
            [class.warning]="(tokenTimeWarningStyle$ | async) === 'alarming'"
            [class.error]="(tokenTimeWarningStyle$ | async) === 'urgent'">
            {{ remainingTime }}
          </p>
        </button>
      }
    </div>

    @if (isMenuVisible$ | async) {
      <coin-v2-card
        padding="none"
        animate.enter="fade-in"
        animate.leave="fade-out">
        <div class="arrow-up"></div>
        @for (menuItem of menuItems$ | async; track menuItem) {
          <div
            class="menu-item"
            role="menu">
            <ng-container *ngTemplateOutlet="menuItemTemplate; context: { menuItem }"></ng-container>
          </div>
        }
      </coin-v2-card>
    }
  </div>
}

<ng-template
  #menuItemTemplate
  let-menuItem="menuItem">
  <button
    class="no-style"
    role="menuitem"
    (click)="openMenuItem(menuItem)">
    @if (menuItem.icon) {
      <mat-icon class="menu-item-icon">{{ menuItem.icon }}</mat-icon>
    }
    <p>{{ menuItem.name | translate }}</p>
    @if (menuItem.subMenuItems?.length > 0) {
      <mat-icon
        class="sub-menu-toggle"
        [class.open]="menuItem.submenuactive">
        keyboard_arrow_right
      </mat-icon>
    }
  </button>

  @if (menuItem.submenuactive) {
    <coin-v2-card
      padding="none"
      animate.enter="fade-in"
      animate.leave="fade-out">
      @for (subMenuItem of menuItem.subMenuItems; track subMenuItem) {
        <div class="sub-menu-item">
          <ng-container *ngTemplateOutlet="menuItemTemplate; context: { menuItem: subMenuItem }"></ng-container>
        </div>
      }
    </coin-v2-card>
  }
</ng-template>
